import React, { useState } from 'react';
import FrequentlyQuestionsComponent from '../FrequentlyQuestionsComponent';

function SubContentHeader() {

  const [openDrawer, setOpenDrawer] = useState(false);

  const showDrawer = () => {
    console.log('showDrawer');
    setOpenDrawer(prevState => !prevState);
    console.log('Drawer open:', openDrawer);
  }

  const handleDrawerClose = () => {
    setOpenDrawer(false);
  };


  return (
    <>
      <FrequentlyQuestionsComponent open={openDrawer} onClose={handleDrawerClose} />
      <div className='subcontentheader_container'>

        <div>
          <h1>COMPRAR PASE MÉDICO</h1>
        </div>

        <div className='help_questions_container' >

          <div className='help_questions_content'>

            <div className='help_questions_text_container' onClick={showDrawer} >
              <h3> ¿Tienes alguna duda? Click Aqui</h3>
            </div>


            <div className='help_questions_img_container'>
              <img src={process.env.PUBLIC_URL + '/robot02.png'} alt="Robot" width='100%' height='100%' loading='lazy' />
            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default SubContentHeader;